import React, { useState } from "react";

const Navdata = () => {
    const [currentActiveMenu, setActiveMenu] = useState<any>({
        dashboard: true,
        doinsight: false,
        blogs: false,
        glossary: false,
        guides: false,
        fluentblogs: false,
    });

    function updateIconSidebar(e: any) {
        if (e && e.target && e.target.getAttribute("sub-items")) {
            const ul: any = document.getElementById("two-column-menu");
            const iconItems: any = ul.querySelectorAll(".nav-icon.active");
            let activeIconItems = [...iconItems];
            activeIconItems.forEach((item) => {
                item.classList.remove("active");
                var id = item.getAttribute("sub-items");
                const getID = document.getElementById(id) as HTMLElement;
                if (getID) getID.classList.remove("show");
            });
        }
    }

    const handelActiveMenu = (menuId: string) => {
        setActiveMenu((prevState: any) => {
            const newState = { ...prevState };
            // Close all menus first
            Object.keys(newState).forEach(key => {
                newState[key] = false;
            });
            // Open the clicked menu
            newState[menuId] = true;
            return newState;
        });
    };

    const toggleDoInsightMenu = (e: any) => {
        e.preventDefault();
        setActiveMenu((prevState: any) => ({
            ...prevState,
            doinsight: !prevState.doinsight,
            dashboard: prevState.doinsight ? false : prevState.dashboard // Keep dashboard state if not opening doinsight
        }));
        updateIconSidebar(e);
    };

    const toggleFluentMenu = (e: any) => {
        e.preventDefault();
        setActiveMenu((prevState: any) => ({
            ...prevState,
            fluentblogs: !prevState.fluentblogs,
            dashboard: prevState.fluentblogs ? false : prevState.dashboard // Keep dashboard state if not opening fluentblogs
        }));
        updateIconSidebar(e);
    }

    const handleSubMenuClick = (e: any, menuId: string) => {
        e.preventDefault();
        handelActiveMenu(menuId);
        updateIconSidebar(e);
    };

    const menuItems: any = [
        {
            id: "dashboard",
            label: "Dashboards",
            icon: "ri-dashboard-2-line",
            link: "/dashboard",
            stateVariables: currentActiveMenu.dashboard,
            checkPermission: true,
            click: function (e: any) {
                e.preventDefault();
                handelActiveMenu("dashboard");
                updateIconSidebar(e);
            },
        },
        {
            id: "doinsight",
            label: "DoInsight.in",
            icon: "ri-global-line",
            stateVariables: currentActiveMenu.doinsight,
            checkPermission: true,
            click: toggleDoInsightMenu,
            subItems: [
                {
                    id: "blogs",
                    label: "Blogs",
                    link: "/blogs",
                    parentId: "doinsight",
                    stateVariables: currentActiveMenu.blogs,
                    click: function (e: any) {
                        handleSubMenuClick(e, "blogs");
                    },
                }
                // {
                //     id: "glossary",
                //     label: "Glossary",
                //     link: "/glossary",
                //     parentId: "doinsight",
                //     stateVariables: currentActiveMenu.glossary,
                //     click: function (e: any) {
                //         handleSubMenuClick(e, "glossary");
                //     },
                // },
                // {
                //     id: "guides",
                //     label: "Guides",
                //     link: "/guides",
                //     parentId: "doinsight",
                //     stateVariables: currentActiveMenu.guides,
                //     click: function (e: any) {
                //         handleSubMenuClick(e, "guides");
                //     },
                // }
            ]
        },
        {
           id: "Fluent",
            label: "Fluent.io",
            icon: "ri-global-line",
            stateVariables: currentActiveMenu.fluentblogs,
            checkPermission: true,
            click: toggleFluentMenu,
            subItems: [
                {
                    id: "fluentblogs",
                    label: "Blogs",
                    link: "/fluent-blog",
                    parentId: "Fluent",
                    stateVariables: currentActiveMenu.fluentblogs,
                    click: function (e: any) {
                        handleSubMenuClick(e, "fluentblogs");
                    },
        }
            ],
        }
    ];

    return <React.Fragment>{menuItems}</React.Fragment>;
};

export default Navdata;